import { useFetch } from '../../../hooks/useFecth';
import { getProposalGates } from '../../../services/proposalGates';

const PAID_STATUSES = new Set(['CONFIRMED', 'RECEIVED', 'CONCLUDED']);

/**
 * Busca e expõe os dados da proposta pública com flags derivadas
 * (gates: skip* = true dispensa a exigência).
 */
export function usePublicProposal(uuid) {
    const { data, error, mutate, isFetching, isValidating } = useFetch(
        uuid ? `subscription/${uuid}` : null,
    );

    const gates = getProposalGates(data);

    const isSigned = Boolean(data?.signedAt);
    const integrationId = data?.integrationId ?? null;
    const clubId = data?.clubId ?? null;

    const planAmount = Number(data?.totalValue ?? 0);
    const planPaid =
        gates.skipPlanPayment || PAID_STATUSES.has(data?.subscription?.paymentStatus);

    const hasCustomization = Boolean(data?.customizationOrder?.Order_products?.length);
    const customAmount = Number(data?.customizationOrder?.total ?? 0);
    const customPaid =
        gates.skipCustomizationPayment ||
        !hasCustomization ||
        PAID_STATUSES.has(data?.customizationOrder?.paymentStatus);

    const signatureOk = gates.skipContractSignature || isSigned;

    const canCreateClub = signatureOk && planPaid && customPaid && !clubId;
    const clubCreated = Boolean(clubId);

    /** Assinatura liberada para cobrança: assinada ou dispensada */
    const canPay = signatureOk;

    return {
        contract: data ?? null,
        error,
        mutate,
        isFetching,
        isValidating,

        gates,
        isSigned,
        signatureOk,
        canPay,
        integrationId,
        clubId,
        planAmount,
        planPaid,
        hasCustomization,
        customAmount,
        customPaid,
        canCreateClub,
        clubCreated,
    };
}
